// extracted by mini-css-extract-plugin
module.exports = {"container":"founders_container__Gcfs_","list":"founders_list__Ohgfm","item":"founders_item__W09iW","isOnlyLogo":"founders_isOnlyLogo__Z4XBA","title":"founders_title__rqYdA"};